import { render, staticRenderFns } from "./FooterPrismic.vue?vue&type=template&id=24736863&scoped=true&"
import script from "./FooterPrismic.vue?vue&type=script&lang=js&"
export * from "./FooterPrismic.vue?vue&type=script&lang=js&"
import style0 from "./FooterPrismic.vue?vue&type=style&index=0&id=24736863&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24736863",
  null
  
)

export default component.exports